import testListReducer from "./testListReducer";

const testPrintReducers = {
    testList: testListReducer
};

export default testPrintReducers;